var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4962_5965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9972 0.00828552C26.8618 0.00828552 0 26.8701 0 60.0055C0 92.182 25.3315 118.443 57.1398 119.933C58.089 119.978 59.0397 120.003 59.998 120.003C75.359 120.003 89.368 114.227 99.9827 104.734C92.9499 109.399 84.7275 112.082 75.9403 112.082C61.6524 112.082 48.8562 104.994 40.2501 93.8166C33.6159 85.9853 29.3189 74.4092 29.0262 61.4177V58.5923C29.3188 45.6012 33.6156 34.0228 40.2484 26.1935C48.8558 15.0159 61.6515 7.92786 75.9386 7.92786C84.728 7.92786 92.9518 10.6115 99.9853 15.2786C89.4226 5.82946 75.4983 0.0653152 60.2228 0.0085907C60.1467 0.0085907 60.0721 0.00562286 59.9959 0.00562286L59.9972 0.00828552Z",
    fill: "url(#paint0_linear_4962_5965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 26.1973C45.7559 19.6975 52.8664 15.778 60.635 15.778C78.102 15.778 92.2591 35.5809 92.2591 60.0086C92.2591 84.4363 78.101 104.239 60.635 104.239C52.8664 104.239 45.7559 100.321 40.2515 93.8213C48.8574 104.999 61.6524 112.087 75.9416 112.087C84.7295 112.087 92.9519 109.403 99.9841 104.739C112.265 93.7527 119.997 77.7842 119.997 60.009C119.997 42.2359 112.266 26.2682 99.9885 15.2831C92.9542 10.616 84.7304 7.93234 75.9418 7.93234C61.6539 7.93234 48.8578 15.0204 40.2517 26.198",
    fill: "url(#paint1_linear_4962_5965)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4962_5965",
    x1: 49.9941,
    y1: 1.96403,
    x2: 49.9941,
    y2: 118.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4962_5965",
    x1: 80.1225,
    y1: 8.82005,
    x2: 80.1225,
    y2: 111.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4962_5965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.0109f29d8bd3a93608471091f722e263.svg";
export { ForwardRef as ReactComponent };